import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput';
import { StyledLabel } from 'elements/Label/Label';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { selectSmartMeterSectionData } from './SmartMeterSection.data';
import { StyleFailureNewDropdown } from '../FailureModeSection/FailureModeSection.styled';

const SmartMeterSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, userRole, isFormReadOnly } = props;
    const dropdownInput = (field) => field.isDropdown ? (
        <StyleFailureNewDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                labelWidth={field.labelWidth}
                width={field.width}
                textAlign={field.textAlign}
                inputTextAlign={field.inputTextAlign}
                marginTop={field.marginTop}
                readOnly={field.readOnly || isFormReadOnly}
                marginLeft={field.marginLeft}
            />
        </StyleFailureNewDropdown>
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isRequired={field.isRequired}
                handleChange={changeHandler}
                labelWidth={field.labelWidth}
                width={field.width}
                marginRight={field.marginRight}
                padding={field.padding}
                type={field.type}
                maxLength={field.maxLength}
                textAlign={field.textAlign}
                userRole={userRole}
                height={field.height}
                marginTop={field.marginTop}
                textAlignLabel={field.textAlignLabel}
                isDisabled={field.isDisabled}
                readOnly={field.readOnly || isFormReadOnly}
                borderRight={field.borderRight}
                marginLeft={field.marginLeft}
            />
        );
    return (
        <div>
            {
                selectSmartMeterSectionData(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            fontWeight={field.fontWeight}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            color={field.color}
                                            fontSize={field.fontSize}
                                            fontStyle={field.fontStyle}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : dropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </div>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SmartMeterSection);

SmartMeterSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
